// カード詳細パネル (= DDSIM-27 Pass 3): hover 中カードを画面右下に拡大表示。
//
// catalog (CardDefDto) から name / type / cost / level / atk-def / race / spell_speed を引く。
// hover していない時は何も描画しない (= レイアウトを一切動かさない overlay)。

import { useCardCatalog } from "./cardCatalog";

export function CardDetail(): JSX.Element | null {
  const { byId, hoveredId } = useCardCatalog();
  if (hoveredId === null) return null;
  const def = byId.get(hoveredId);
  if (def === undefined) return null;

  const isMonster = def.card_type === "monster";
  return (
    <div className="pointer-events-none fixed bottom-4 right-4 z-50 w-48 rounded-lg border border-slate-600 bg-slate-900/95 p-3 text-slate-100 shadow-xl">
      <div className="mb-1 text-sm font-bold leading-tight">{def.name}</div>
      <div className="mb-2 flex flex-wrap gap-1 text-[10px]">
        <span className="rounded bg-slate-700 px-1.5 py-0.5 uppercase">
          {def.card_type}
        </span>
        <span className="rounded bg-slate-700 px-1.5 py-0.5">COST {def.cost}</span>
        {isMonster && (
          <span className="rounded bg-slate-700 px-1.5 py-0.5">Lv{def.level}</span>
        )}
      </div>
      {def.atk !== null && def.def !== null && (
        <div className="mb-2 text-xs font-medium">
          <span className="text-rose-300">ATK {def.atk}</span>
          {" / "}
          <span className="text-sky-300">DEF {def.def}</span>
        </div>
      )}
      {def.race.length > 0 && (
        <div className="text-[10px] text-slate-400">{def.race.join(" / ")}</div>
      )}
      <div className="mt-1 text-[10px] text-slate-500">
        {def.card_id_str} · {def.spell_speed}
      </div>
    </div>
  );
}
